function buildNodeTree(nodes, depth = 0, parent, refMap = /* @__PURE__ */ new WeakMap()) {
  const tree = [];
  const map = {};
  nodes.forEach((node, index) => {
    const nodeWithMetadata = {
      node,
      index,
      depth,
      parent,
      children: []
    };
    const nodeKey = node.id || `${depth}-${index}`;
    map[nodeKey] = nodeWithMetadata;
    refMap.set(node, nodeWithMetadata);
    if (node.nodes && node.nodes.length > 0) {
      const { tree: childTree, map: childMap } = buildNodeTree(
        node.nodes,
        depth + 1,
        nodeWithMetadata,
        refMap
      );
      nodeWithMetadata.children = childTree;
      Object.assign(map, childMap);
    }
    tree.push(nodeWithMetadata);
  });
  return { tree, map, refMap };
}
export {
  buildNodeTree
};
//# sourceMappingURL=node-tree-traversal.js.map
